import { useRef } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { ColorPickerIcon } from './optionsIcons';
import { Sketch } from '@uiw/react-color';
import { DEFAULT_FONT_COLOR } from '@/constants/constants';

const DropdownContainer = styled.div`
  margin-right: 6px;
`;

const DropdownButton = styled.button`
  cursor: pointer;
  height: 16px;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c5c7d0;
  font-size: 9px;
  color: #676879;
  font-weight: 600;
  border-radius: 3px;
  padding-left: 4px;
  padding-right: 4px;
  gap: 4px;

  &:hover {
    opacity: 0.8;
    background-color: rgb(247, 248, 249);
  }
  &.active {
    background-color: #0073ea;
    border: 1px solid #0073ea;
  }
`;
const ColorPreviewer = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${({ color }) => (color ? color : 'white')};
  border: none;
`;

const DropdownContent = styled.div`
  margin-top: 8px;
  position: absolute;
  left: 6%;
  background-color: white;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  border-radius: 5px;
`;

const OptionsBarColorPicker = ({ color, onClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hex, setHex] = useState(color || DEFAULT_FONT_COLOR); //this is for updating small preview in options bar
  const dropdownRef = useRef(null);

  const triggerDropdown = () => {
    setIsOpen((s) => !s);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <>
      <DropdownContainer ref={dropdownRef}>
        <DropdownButton onClick={triggerDropdown}>
          <ColorPreviewer
            color={`rgb(${hex.r}, ${hex.g}, ${hex.b})`}
          ></ColorPreviewer>
          <ColorPickerIcon />
        </DropdownButton>
        {isOpen ? (
          <DropdownContent>
            <Sketch
              color={`rgb(${hex.r}, ${hex.g}, ${hex.b})`}
              onChange={(color) => {
                setHex(color.rgb);
                onClick(color.rgb);
              }}
            />
          </DropdownContent>
        ) : null}
      </DropdownContainer>
    </>
  );
};

export default OptionsBarColorPicker;
